export default __webpack_public_path__ + "static/media/04.36e00c9b.jpg";